
import Vue, { PropType } from 'vue'

type RTooltipPosition = 'top-middle' | 'top-left'

export default Vue.extend({
  name: 'RTooltip',
  props: {
    position: {
      type: String as PropType<RTooltipPosition>,
      default: 'top-middle',
    },
  },
  data() {
    return {
      show: false,
    }
  },
})
